import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import css from './style.css'
import Label from '../label'
import Input from '../input'
import Button from '../button'
import SelectForm from '../select-form'
import { isEmail } from '../../utils'
import { Grid, GridItem } from '../grid'
import { clientSaveChangesClicked } from '../../actions/client'
import normalizePhone from './normalize-phone'

const HOW_YOU_HEARD = [
  {value: 'referral', label: 'Referral'},
  {value: 'onlineSearch', label: 'Online Search'},
  {value: 'socialmedia', label: 'Social Media'},
  {value: 'advertisement', label: 'Advertisement'},
  {value: 'other', label: 'Other'}
]

const PRODUCTS = [
  {value: 'Engagement Ring', label: 'Engagement Ring'},
  {value: "Women's Band", label: "Women's Band"},
  {value: "Men's Band", label: "Men's Band"},
  {value: 'Diamond Ring', label: 'Diamond Ring'},
  {value: 'Other Ring', label: 'Other Ring'},
  {value: 'Earrings', label: 'Earrings'},
  {value: 'Necklace', label: 'Necklace'},
  {value: 'Pendant', label: 'Pendant'},
  {value: 'Bracelet', label: 'Bracelet'},
  {value: 'Other', label: 'Other'}
]

const renderInput = ({input, type, meta: {touched, error}}) =>
  <div>
    <Input {...input} type={type} touched={touched} error={error} pad />
  </div>

const renderSelect = ({input, options, multi}) =>
  <SelectForm
    multi={multi}
    options={options}
    value={input.value}
    values={input.values}
    onChange={input.onChange}
    onBlur={() => input.onBlur(input.value)}
  />

let ClientForm = props => {
  const { handleSubmit, submitting, pristine, invalid, submitSucceeded, dirty } = props
  const submit = data => data
  return (
    <div className={css.container}>
      <form onSubmit={handleSubmit(submit)}>
        <Grid>
          <GridItem col='1/2'>
            <Label>Client First Name (Required)</Label>
            <Field name='clientFirstName' component={renderInput} />
          </GridItem>
          <GridItem col='1/2'>
            <Label>Client Last Name (Required)</Label>
            <Field name='clientLastName' component={renderInput} />
          </GridItem>
        </Grid>
        <Grid>
          <GridItem col='1/2'>
            <Label>Partner First Name</Label>
            <Field name='partnerFirstName' component={renderInput} />
          </GridItem>
          <GridItem col='1/2'>
            <Label>Partner Last Name</Label>
            <Field name='partnerLastName' component={renderInput} />
          </GridItem>
        </Grid>
        <Grid>
          <GridItem col='1/2'>
            <Label>Phone Number</Label>
            <Field name='phoneNumber' component={renderInput} normalize={normalizePhone} />
          </GridItem>
          <GridItem col='1/2'>
            <Label>Email (Required)</Label>
            <Field name='email' component={renderInput} />
          </GridItem>
        </Grid>
        <Grid>
          <GridItem col='1/2'>
            <Label>Location</Label>
            <Field name='location' component={renderInput} />
          </GridItem>
          <GridItem col='1/2'>
            <Label>Product</Label>
            <Field name='product' component={renderSelect} options={PRODUCTS} multi />
          </GridItem>
        </Grid>
        <Grid>
          <GridItem col='1/2'>
            <Label>How You Heard About Us</Label>
            <Field name='howYouHeard' component={renderSelect} options={HOW_YOU_HEARD} />
          </GridItem>
          <GridItem col='1/2'>
            <Label>Referral Notes</Label>
            <Field name='referralNotes' component={renderInput} />
          </GridItem>
        </Grid>
        <Label>Additional Notes</Label>
        <Field name='additionalNotes' component={renderInput} type='textarea' />
        <Button disabled={pristine || submitting || invalid}
          center
          onClick={handleSubmit(submit)}>
          Save Changes
        </Button>
        {submitSucceeded && !dirty ? <div className={css.success}>Client profile saved.</div> : ''}
      </form>
    </div>
  )
}

const validate = (values, props) => {
  const errors = {}
  if (!values.email) {
    errors.email = 'Required.'
  } else if (!isEmail(values.email)) {
    errors.email = 'Please enter a valid email address.'
  }
  if (!values.clientFirstName) {
    errors.clientFirstName = 'Required.'
  }
  if (!values.clientLastName) {
    errors.clientLastName = 'Required.'
  }
  return errors
}

ClientForm = reduxForm({
  form: 'clientProfile',
  validate,
  onSubmitSuccess: (result, dispatch) => {
    dispatch(clientSaveChangesClicked(result.data))
  }
})(ClientForm)

ClientForm = connect(
  state => ({ initialValues: state.client })
)(ClientForm)

export default ClientForm



// WEBPACK FOOTER //
// ./src/components/client-form/index.js